import { render } from "./filter-sorting.vue?vue&type=template&id=298a1cc0"
import script from "./filter-sorting.vue?vue&type=script&lang=js"
export * from "./filter-sorting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__